import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2353dcc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-sku-box" }
const _hoisted_2 = { class: "change-title-box" }
const _hoisted_3 = { class: "change-content-box" }
const _hoisted_4 = { class: "change-button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, "修改价格" + _toDisplayString(_ctx.skuTitle), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ui_form, { ref: "form" }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_form_item, {
            label: "价格",
            data: _ctx.postData.price,
            required: true,
            showError: false,
            rule: _ctx.validatePrice
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.postData.price,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postData.price) = $event)),
                validate: "decimal"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["data", "rule"])
        ]),
        _: 1
      }, 512)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        onClick: _ctx.confirm
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      }, 8, ["onClick"])), [
        [_directive_loading, _ctx.submitLoading]
      ]),
      _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}